import { render } from "./required-vote-badge.vue?vue&type=template&id=97fa9e86"
import script from "./required-vote-badge.vue?vue&type=script&lang=js"
export * from "./required-vote-badge.vue?vue&type=script&lang=js"

import exportComponent from "/Users/ars62917/Dropbox/voteomatic/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__